export const zIndex = {
    MODAL: 100,
    UPLOAD_BOX: 50,
    NAVBAR: 30,
}
